import { useState } from "react";

import Header from '../../../components/feature/Header_v2';
import Footer from '../../../components/feature/Footer_v2';
import HeroSection from './components/HeroSection';
import ClassesSection from './components/ClassesSection';
import FeaturesSliderSection from './components/FeaturesSliderSection';
import MembershipSection from './components/MembershipSection';
import AppPromoSection from "./components/AppPromoSection";
import ContactSection from './components/ContactSection';


const PASSWORD = "847501873";

export default function Home() {
    const [isAuthorized, setIsAuthorized] = useState(false);
    const [input, setInput] = useState("");

    const handleSubmit = () => {
        if (input === PASSWORD) {
            setIsAuthorized(true);
        } else {
            alert("wrong password");
        }
    };

    if (!isAuthorized) {
        return (
            <div className="flex items-center justify-center h-screen">
                <div>
                    <h2>Enter Password</h2>
                    <input
                        style={{background:"#e4e4e4"}}
                        type="password"
                        value={input}
                        onChange={(e) => setInput(e.target.value)}
                    />
                    <div>
                            <button onClick={handleSubmit}>Enter</button>
                    </div>
                </div>
            </div>
        );
    }

    return (
    <div className="min-h-screen home-v2">
      <Header />
      <main>
        <HeroSection />
        <ClassesSection />
        <FeaturesSliderSection />
        <MembershipSection />
        <AppPromoSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
